const INITIAL_STATE = {
    material: {},
    materials: [],
    partnumbers: {},
    filter: {},
    logs: [],
    log: {},
    resourceStock: {},
    mailers: [],
    mailer: {},
    palletLabelsPaged: {},
    palletLabel: {},
    lowHours: {}
};

export default function stockReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_LOGS':
            return {
                ...state,
                logs: action.logs,
            };
        case 'SELECT_LOG':
            return {
                ...state,
                log: action.log,
            }
        case 'SET_RESOURCE_STOCK': {
            return {
                ...state,
                resourceStock: action.resourceStock,
            };
        }
        case 'SET_LOW_HOURS': {
            return {
                ...state,
                lowHours: action.lowHours
            };
        }
        case 'SET_MATERIALS': {
            return {
                ...state,
                materials: action.materials
            };
        }
        case 'ADD_MATERIAL': {
            let materialList = [];
            Object.assign(materialList, state.materials);

            materialList.push(action.material);
            return {
                ...state,
                materials: materialList
            };
        }
        case 'REMOVE_MATERIAL': {
            let materialList = [];
            Object.assign(materialList, state.materials);
            materialList = materialList?.filter((i) => i.id !== action.material.id);
            return {
                ...state,
                materials: materialList
            };
        }
        case 'CLEAR_MATERIALS': {
            return {
                ...state,
                materials: INITIAL_STATE.materials
            };
        }
        case 'SET_FILTER_DIFFUSIONS':
        case 'SET_FILTER_STOCK': {
            return {
                ...state,
                filter: action.filter,
            };
        }
        case 'CLEAR_FILTER': {
            return {
                ...state,
                filter: INITIAL_STATE.filter,
            }
        }
        case 'SET_PARTNUMBERS': {
            return {
                ...state,
                partnumbers: action.partnumbers,
            }
        }
        case 'SET_PARTNUMBER': {
            return {
                ...state,
                partnumber: action.partnumber,
            }
        }
        case 'SET_AREAS':
            return {
                ...state,
                areas: action.areas,
            };
        case 'SET_AREA': {
            return {
                ...state,
                area: action.area,
            }
        }
        case 'SET_ULES':
            return {
                ...state,
                ules: action.ules,
            };
        case 'SET_ULE': {
            return {
                ...state,
                ule: action.ule,
            }
        }
        case 'SET_VEHICLES':
            return {
                ...state,
                vehicles: action.vehicles,
            };
        case 'SET_VEHICLE': {
            return {
                ...state,
                vehicle: action.vehicle,
            }
        }
        case 'SET_QUESTIONS':
            return {
                ...state,
                questions: action.questions,
            };
        case 'SET_QUESTION': {
            return {
                ...state,
                question: action.question,
            }
        }
        case 'SET_DEEMS':
            return {
                ...state,
                deems: action.deems,
            };
        case 'SET_DEEM': {
            return {
                ...state,
                deem: action.deem,
            }
        }
        case 'SET_SQPS':
            return {
                ...state,
                sqps: action.sqps,
            };
        case 'SET_SQP': {
            return {
                ...state,
                sqp: action.sqp,
            }
        }
        case 'SET_MAILERS':
            return {
                ...state,
                mailers: action.mailers,
            };
        case 'SET_MAILER': {
            return {
                ...state,
                mailer: action.mailer,
            }
        }
        case 'SET_PALLET_LABEL': {
            return {
                ...state,
                palletLabel: action.palletLabel,
            }
        }
        case 'SET_PALLETS_LABEL_PAGED': {
            return {
                ...state,
                palletLabelsPaged: action.palletsLabels,
            }
        }
        case 'SET_DIFFUSIONS': {
            return {
                ...state,
                diffusions: action.items,
            };
        }
        case 'SELECT_DIFFUSION_LOG': {
            console.log("Action", action);
            return {
                ...state,
                diffusionLog: action.diffusionLog,
            };
        }
        default:
            return state;
    }
}



